'use strict'

function loadingBarFactory ($q, $rootScope, $log, cfpLoadingBar) {
  var numLoadings = 0

  return {
    request: function (config) {
      numLoadings++
      $rootScope.$broadcast('loader_show')
      cfpLoadingBar.start()
      return config || $q.when(config)
    },
    response: function (response) {
      if (numLoadings > 0) --numLoadings
      if (numLoadings === 0) {
        $rootScope.$broadcast('loader_hide')
        cfpLoadingBar.complete()
      }
      return response || $q.when(response)
    },
    responseError: function (response) {
      if (numLoadings > 0) --numLoadings
      if (numLoadings === 0) {
        $rootScope.$broadcast('loader_hide')
        cfpLoadingBar.complete()
      }
      return $q.reject(response)
    }
  }
}

function loagingBarConfig ($httpProvider) {
  $httpProvider.interceptors.push('loadingBarFactory')
}

angular
  .module('app')
  .factory('loadingBarFactory', loadingBarFactory)
  .config(loagingBarConfig)



//////////////////
// WEBPACK FOOTER
// ./factories/loading-bar.factory.js
// module id = 95
// module chunks = 0